module.exports = __webpack_public_path__ + "static/img/1.29560cd.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/jxhh/1.png
// module id = uUMG
// module chunks = 2